import * as types from 'actionTypes/filters';

export const setFilter = (name, key, value) => ({
  type: types.SET_FILTER,
  payload: { name, key, value }
});